import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from './services/config.service';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({ imports: [CommonModule], providers: [ConfigService, HttpClient, provideHttpClient(withInterceptorsFromDi())] })
export class AbcCoreConfigurationModule {}
